'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ContentArea = require('@icare/components/lib/ContentArea');

var _ContentArea2 = _interopRequireDefault(_ContentArea);

var _layouts = require('@icare/layouts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentTiles = (_temp = _class = function (_React$Component) {
	_inherits(ContentTiles, _React$Component);

	function ContentTiles() {
		_classCallCheck(this, ContentTiles);

		return _possibleConstructorReturn(this, (ContentTiles.__proto__ || Object.getPrototypeOf(ContentTiles)).apply(this, arguments));
	}

	_createClass(ContentTiles, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_layouts.Layout,
				{ type: _layouts.Layout.Type.ONE_COLUMN, className: 'content-tiles' },
				_react2.default.createElement(
					'h2',
					{ className: (0, _classnames2.default)('h1', 'm-t-l') },
					this.props.title
				),
				_react2.default.createElement(_ContentArea2.default, { content: this.props.content.contentTileHtml })
			);
		}
	}]);

	return ContentTiles;
}(_react2.default.Component), _class.propTypes = {
	content: _propTypes2.default.object.isRequired,
	title: _propTypes2.default.string
}, _class.defaultProps = {
	title: 'Resources'
}, _temp);
exports.default = ContentTiles;
//# sourceMappingURL=ContentTiles.js.map